// src/core/contract.ts
function allOf() {
  return (list) => list;
}
var QUESTION_TYPES = allOf()([
  "rating",
  "long_text",
  "short_text",
  "choice",
  "boolean",
  "number",
  "date"
]);
var ERROR_CODES = allOf()([
  "invalid",
  "forbidden",
  "not_found",
  "disabled",
  "settled",
  "closed",
  "required",
  "not_due"
]);

// src/core/errors.ts
var BRAND = /* @__PURE__ */ Symbol.for("huginn.FeedbackError");
var FeedbackError = class extends Error {
  constructor({ status, detail, code = null, errors = {}, cause }) {
    super(detail);
    this.name = "FeedbackError";
    this.status = status;
    this.code = code;
    this.detail = detail;
    this.errors = errors;
    this.cause = cause;
    Object.defineProperty(this, BRAND, { value: true });
  }
};
function isFeedbackError(value) {
  return typeof value === "object" && value !== null && value[BRAND] === true;
}
function isRecord(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
function isErrorCode(value) {
  return typeof value === "string" && ERROR_CODES.includes(value);
}
function readErrors(value) {
  if (!isRecord(value)) return {};
  const errors = {};
  for (const [path, messages] of Object.entries(value)) {
    const list = Array.isArray(messages) ? messages : [messages];
    const texts = list.filter((message) => typeof message === "string");
    if (texts.length > 0) errors[path] = texts;
  }
  return errors;
}
function fallbackDetail(status) {
  return status === 0 ? "The feedback service could not be reached." : `The feedback request failed (${status}).`;
}
function errorFromResponse(status, body, cause) {
  if (isRecord(body)) {
    const detail = typeof body.detail === "string" && body.detail ? body.detail : fallbackDetail(status);
    return new FeedbackError({
      status,
      detail,
      code: isErrorCode(body.code) ? body.code : null,
      errors: readErrors(body.errors),
      cause
    });
  }
  return new FeedbackError({ status, detail: fallbackDetail(status), cause });
}
function normalizeError(error) {
  if (isFeedbackError(error)) return error;
  if (isRecord(error)) {
    const response = isRecord(error.response) ? error.response : { status: error.status, data: error.body };
    if (typeof response.status === "number") return errorFromResponse(response.status, response.data, error);
  }
  const detail = error instanceof Error && error.message ? error.message : fallbackDetail(0);
  return new FeedbackError({ status: 0, detail, cause: error });
}
function settlement(error) {
  if (error.status !== 409) return null;
  return error.code === "settled" || error.code === "closed" ? error.code : null;
}
function answerErrors(error) {
  const byKey = {};
  for (const [path, messages] of Object.entries(error.errors)) {
    if (path === "answers") byKey[""] = messages[0];
    else if (path.startsWith("answers.")) byKey[path.slice("answers.".length)] = messages[0];
  }
  return byKey;
}

export {
  QUESTION_TYPES,
  ERROR_CODES,
  FeedbackError,
  isFeedbackError,
  isRecord,
  errorFromResponse,
  normalizeError,
  settlement,
  answerErrors
};
